import { Model } from '@vuex-orm/core'

export default class Class extends Model {
  static entity = 'badges'

  static fields() {
    return {
      id: this.string(''),
      lesson_id: this.attr(''),
      lesson_slug: this.attr('null'),
      image_url: this.attr('null'),
      name: this.string(''),
      description: this.string(null),
      badge_received_description: this.string(null),
      created_at: this.attr('')
    }
  }
}
